import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { MasterMixTicketDataModel } from 'shared/models';
import { PastePreparationService } from '../../paste-preparation/PastePreparationService';
import { TenantContextService } from 'shared/core';
import { partLabel } from '../../workplan-list/vessel-split.util';

@Component({
  selector: 'app-master-mix-ticket-print',
  templateUrl: './master-mix-ticket-print.component.html',
  styleUrls: ['./master-mix-ticket-print.component.less'],
  standalone: false,
})
export class MasterMixTicketPrintComponent implements OnInit, OnDestroy {
  data: MasterMixTicketDataModel | null = null;
  isLoading = true;
  masterMixBatchNumber = '';

  private route$ = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private pastePreparationService: PastePreparationService,
    private tenantContext: TenantContextService,
  ) {}

  ngOnInit(): void {
    this.route$ = this.route.params.subscribe((p: Params) => {
      this.masterMixBatchNumber = p['masterMixBatchNumber'];
      this.load();
    });
  }

  ngOnDestroy(): void {
    this.route$.unsubscribe();
  }

  private load(): void {
    if (!this.masterMixBatchNumber) {
      this.isLoading = false;
      return;
    }
    this.pastePreparationService.getMasterMixTicket(this.masterMixBatchNumber).subscribe({
      next: (d) => {
        this.data = d;
        this.isLoading = false;
        // A fresh print tab may still be loading the company details for the header.
        this.tenantContext.whenCompanyInfoReady().then(() => setTimeout(() => window.print(), 500));
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  get mixingLabel(): string {
    return this.data ? partLabel(this.data.MixingName, this.data.SubBatchSequence, this.data.SubBatchCount) : '';
  }
}
